import { Decorators } from "../../decorators";

export interface ScriptContext {
}

@Decorators.registerClass('Serenity.ScriptContext')
export class ScriptContext {
}